export enum SwapOrderStatus {
  /** 处理中 */
  processing = 1,
  /** 成功 */
  success = 2,
  /** 失败 */
  fail = 3,
  /** 回滚 */
  rollback = 4,
}

export enum SwapTxType {
  /** 1: approval */
  approval = 1,
  /** 2: a chain transfer */
  aChainTransfer = 2,
  /** 3: b chain transfer */
  bChainTransfer = 3,
  /** 4: a chain refund */
  aChainRefund = 4,
}
